var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "message-box dialog-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickOutSide.apply(null, arguments)
        },
      },
    },
    [
      !_vm.previewVersionId
        ? _c("div", { staticClass: "dialog-box" }, [
            _c("div", { staticClass: "dialog-header" }, [
              _c("span", { staticClass: "empty" }),
              _c("span", { staticClass: "font-bold" }, [
                _vm._v(_vm._s(_vm.$t("versionsDialog.title"))),
              ]),
              _c(
                "span",
                { staticClass: "close", on: { click: _vm.onClickOutSide } },
                [_vm._v(_vm._s(_vm.$t("versionsDialog.closeWindow")))]
              ),
            ]),
            _c("div", { staticClass: "dialog-body" }, [
              _vm.isFree
                ? _c("div", { staticClass: "premium-guide" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("versionsDialog.premiumGuide.title"))
                      ),
                    ]),
                    _c("div", { staticClass: "container" }, [
                      _c("div", { staticClass: "text" }, [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("versionsDialog.premiumGuide.description")
                            ),
                          },
                        }),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "button subscription",
                          on: { click: _vm.onClickSubscription },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("versionsDialog.premiumGuide.checkPlans")
                            )
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _c("div", { staticClass: "description" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("versionsDialog.description"))),
                    ]),
                    _c("br"),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("versionsDialog.descriptionDetail")) +
                        " "
                    ),
                  ]),
              _c(
                "div",
                { staticClass: "version-list" },
                _vm._l(_vm.versionDates, function (date) {
                  return _c(
                    "div",
                    { key: date, staticClass: "list-item-container" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "version-date",
                          on: {
                            click: function ($event) {
                              return _vm.onToggleAccordion(date)
                            },
                          },
                        },
                        [
                          _c("chevron-down-icon", {
                            staticClass: "icon",
                            class: { opened: _vm.openedDate(date) },
                          }),
                          _c("div", { staticClass: "date" }, [
                            _vm._v(_vm._s(_vm.lastModifiedTime(date))),
                          ]),
                        ],
                        1
                      ),
                      _vm.openedDate(date)
                        ? _c(
                            "div",
                            _vm._l(
                              _vm.versionsByDate(date),
                              function (version) {
                                return _c(
                                  "div",
                                  {
                                    key: version.versionId,
                                    staticClass: "list-item",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "last-modified ellipsis" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              version.isLatest
                                                ? _vm.$t(
                                                    "versionsDialog.current"
                                                  )
                                                : _vm.lastModifiedDate(
                                                    version.lastModified
                                                  )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c("div", [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "button default mr-1",
                                          attrs: { disabled: _vm.isFree },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onClickPreview(
                                                version.versionId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("versionsDialog.preview")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "button primary",
                                          attrs: { disabled: _vm.isFree },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onClickVersion(
                                                version.versionId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("versionsDialog.restore")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]),
          ])
        : _c("div", { staticClass: "dialog-box preview" }, [
            _c("div", { staticClass: "dialog-header" }, [
              _c(
                "span",
                { staticClass: "back", on: { click: _vm.onClickBack } },
                [_vm._v(_vm._s(_vm.$t("versionsDialog.backToHistory")))]
              ),
              _c("span", { staticClass: "font-bold" }, [
                _vm._v(_vm._s(_vm.$t("versionsDialog.previewTitle"))),
              ]),
              _c(
                "span",
                { staticClass: "close", on: { click: _vm.onClickOutSide } },
                [_vm._v(_vm._s(_vm.$t("versionsDialog.closeWindow")))]
              ),
            ]),
            _c("div", { staticClass: "dialog-body preview" }, [
              _vm.existsDiff
                ? _c(
                    "div",
                    { staticClass: "diff-wrapper" },
                    [
                      _c("div", { staticClass: "diff-header" }, [
                        _c("div", { staticClass: "diff-old" }, [
                          _vm._v(
                            _vm._s(_vm.$t("versionsDialog.diff.currentData"))
                          ),
                        ]),
                        _c("div", { staticClass: "diff-new" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("versionsDialog.diff.selectedHistory")
                            )
                          ),
                        ]),
                      ]),
                      _c("code-diff", {
                        ref: "diff",
                        staticClass: "diff",
                        attrs: {
                          oldString: _vm.content,
                          newString: _vm.previewContent,
                          outputFormat: "side-by-side",
                          language: "text",
                          renderNothingWhenEmpty: true,
                        },
                        on: { "after-render": _vm.afterRenderDiff },
                      }),
                    ],
                    1
                  )
                : _c("div", { staticClass: "nothing-diff" }, [
                    _vm._v(_vm._s(_vm.$t("versionsDialog.diff.noChanges"))),
                  ]),
            ]),
            _c("div", { staticClass: "dialog-footer" }, [
              _c(
                "button",
                {
                  staticClass: "button primary large",
                  attrs: { disabled: _vm.isFree },
                  on: {
                    click: function ($event) {
                      return _vm.onClickVersion(_vm.previewVersionId)
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("versionsDialog.executeRestore")) + " "
                  ),
                ]
              ),
            ]),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }